import { render } from "./login-page.vue?vue&type=template&id=24437a23"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"

import "./login-page.vue?vue&type=style&index=0&id=24437a23&lang=css"
script.render = render

export default script